import { API } from "./api";

export const getCompanyProfileData = (id) => {
  return API.get(`/companies/${id}`);
};
export const addCompanyProfileDetails = (details) =>
  API.post("/companies", details);
export const updateCompanyProfileDetails = (id, details) =>
  API.put(`/companies/${id}`, details);
